import { render, staticRenderFns } from "./ServiceScreenLayout.vue?vue&type=template&id=bb42b11e&"
import script from "./ServiceScreenLayout.vue?vue&type=script&lang=js&"
export * from "./ServiceScreenLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports